// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.requestTracking_h_status__UEinq {
  height: 39px !important;
}

.requestTracking_label_margin__H2v2Q {
  margin-top: -7px !important;
}
.requestTracking_filter_today__QsRof {
  background: #bacdff;
}
.requestTracking_filter_returned__VtEtL {
  background: #Ff4b4b;
}
.requestTracking_filter_shipping__1qul2 {
  background: #86b4b5;
  /* width: 100px; */
}
.requestTracking_filter_pending__MRGFC {
  background: #FE9F44;
}
.requestTracking_filter_ready__GJRKx {
  background: #Feff6b;
}
svg {
  width: 18px !important;
  margin-top: 2px;
  margin-right: 2px;
}
.requestTracking_status__JKZV3 {
  background: red;
  padding: 2px 20px;
  color: #dfdfdf;
}
.requestTracking_file_upload__yjZlt input[type="file"] {
  display: none;
}
@media only screen and (max-width: 991px) {
  /* For tablets: */

  .requestTracking_info_boxes__UXOG- {
    width: 90%;
  }
  .requestTracking_info_box__QuuhK {
    margin-bottom: 10px;
  }
  .requestTracking_input-boxes__Rwy2s {
    width: 100%;
  }
  .requestTracking_backHeader__dF4H6 {
    width: 100%;
  }
}
.requestTracking_hidden-xs-up__ScsMO {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/requestTracking/requestTracking.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;;EAEjB;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,aAAa;AACf","sourcesContent":[".h_status {\n  height: 39px !important;\n}\n\n.label_margin {\n  margin-top: -7px !important;\n}\n.filter_today {\n  background: #bacdff;\n}\n.filter_returned {\n  background: #Ff4b4b;\n}\n.filter_shipping {\n  background: #86b4b5;\n  /* width: 100px; */\n}\n.filter_pending {\n  background: #FE9F44;\n}\n.filter_ready {\n  background: #Feff6b;\n}\nsvg {\n  width: 18px !important;\n  margin-top: 2px;\n  margin-right: 2px;\n}\n.status {\n  background: red;\n  padding: 2px 20px;\n  color: #dfdfdf;\n}\n.file_upload input[type=\"file\"] {\n  display: none;\n}\n@media only screen and (max-width: 991px) {\n  /* For tablets: */\n\n  .info_boxes {\n    width: 90%;\n  }\n  .info_box {\n    margin-bottom: 10px;\n  }\n  .input-boxes {\n    width: 100%;\n  }\n  .backHeader {\n    width: 100%;\n  }\n}\n.hidden-xs-up {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"h_status": `requestTracking_h_status__UEinq`,
	"label_margin": `requestTracking_label_margin__H2v2Q`,
	"filter_today": `requestTracking_filter_today__QsRof`,
	"filter_returned": `requestTracking_filter_returned__VtEtL`,
	"filter_shipping": `requestTracking_filter_shipping__1qul2`,
	"filter_pending": `requestTracking_filter_pending__MRGFC`,
	"filter_ready": `requestTracking_filter_ready__GJRKx`,
	"status": `requestTracking_status__JKZV3`,
	"file_upload": `requestTracking_file_upload__yjZlt`,
	"info_boxes": `requestTracking_info_boxes__UXOG-`,
	"info_box": `requestTracking_info_box__QuuhK`,
	"input-boxes": `requestTracking_input-boxes__Rwy2s`,
	"backHeader": `requestTracking_backHeader__dF4H6`,
	"hidden-xs-up": `requestTracking_hidden-xs-up__ScsMO`
};
export default ___CSS_LOADER_EXPORT___;
